(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["added-home-clean"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-an-home-gallery]').forEach((gallery) => {
    const slides = gallery.querySelector('[data-an-home-slides]');
    const dots = Array.from(gallery.querySelectorAll('[data-an-home-dot]'));
    const previousButton = gallery.querySelector('[data-an-home-previous]');
    const nextButton = gallery.querySelector('[data-an-home-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let autoplayTimer;
    let scrollFrame;

    const updateActiveSlide = (index) => {
      activeIndex = (index + dots.length) % dots.length;
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const showSlide = (index) => {
      updateActiveSlide(index);
      slides.scrollTo({ left: slides.clientWidth * activeIndex, behavior: 'smooth' });
    };

    const stopAutoplay = () => {
      window.clearTimeout(autoplayTimer);
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (reducedMotion.matches || document.hidden) return;
      autoplayTimer = window.setTimeout(() => {
        showSlide(activeIndex + 1);
        startAutoplay();
      }, 7000);
    };

    const showManualSlide = (index) => {
      showSlide(index);
      startAutoplay();
    };

    previousButton.addEventListener('click', () => showManualSlide(activeIndex - 1));
    nextButton.addEventListener('click', () => showManualSlide(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => showManualSlide(Number(dot.dataset.anHomeDot))));

    slides.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const index = Math.round(slides.scrollLeft / slides.clientWidth);
        if (index !== activeIndex) updateActiveSlide(index);
      });
    });

    gallery.addEventListener('mouseenter', stopAutoplay);
    gallery.addEventListener('mouseleave', startAutoplay);
    gallery.addEventListener('focusin', stopAutoplay);
    gallery.addEventListener('focusout', startAutoplay);
    slides.addEventListener('touchstart', stopAutoplay, { passive: true });
    slides.addEventListener('touchend', startAutoplay, { passive: true });
    document.addEventListener('visibilitychange', startAutoplay);
    reducedMotion.addEventListener('change', startAutoplay);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["added-sleep-tester"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tester-gallery]').forEach((gallery) => {
    const slides = gallery.querySelector('[data-tester-slides]');
    const dots = Array.from(gallery.querySelectorAll('[data-tester-dot]'));
    const previousButton = gallery.querySelector('[data-tester-previous]');
    const nextButton = gallery.querySelector('[data-tester-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let autoplayTimer;
    let scrollFrame;

    const updateActiveSlide = (index) => {
      activeIndex = (index + dots.length) % dots.length;
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const showSlide = (index) => {
      updateActiveSlide(index);
      slides.scrollTo({ left: slides.clientWidth * activeIndex, behavior: 'smooth' });
    };

    const stopAutoplay = () => {
      window.clearTimeout(autoplayTimer);
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (reducedMotion.matches || document.hidden) return;
      autoplayTimer = window.setTimeout(() => {
        showSlide(activeIndex + 1);
        startAutoplay();
      }, 7000);
    };

    const showManualSlide = (index) => {
      showSlide(index);
      startAutoplay();
    };

    previousButton.addEventListener('click', () => showManualSlide(activeIndex - 1));
    nextButton.addEventListener('click', () => showManualSlide(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => showManualSlide(Number(dot.dataset.testerDot))));

    slides.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const index = Math.round(slides.scrollLeft / slides.clientWidth);
        if (index !== activeIndex) updateActiveSlide(index);
      });
    });

    gallery.addEventListener('mouseenter', stopAutoplay);
    gallery.addEventListener('mouseleave', startAutoplay);
    gallery.addEventListener('focusin', stopAutoplay);
    gallery.addEventListener('focusout', startAutoplay);
    slides.addEventListener('touchstart', stopAutoplay, { passive: true });
    slides.addEventListener('touchend', startAutoplay, { passive: true });
    document.addEventListener('visibilitychange', startAutoplay);
    reducedMotion.addEventListener('change', startAutoplay);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sliders = document.querySelectorAll('[data-an-testimonial-slider]');

    sliders.forEach(function (slider) {
      var track = slider.querySelector('[data-an-track]');
      var slides = slider.querySelectorAll('[data-an-slide]');
      var prev = slider.querySelector('[data-an-prev]');
      var next = slider.querySelector('[data-an-next]');
      var dots = slider.querySelectorAll('[data-an-dot]');
      var index = 0;

      function goToSlide(newIndex) {
        if (!track || !slides.length) return;

        if (newIndex < 0) {
          index = slides.length - 1;
        } else if (newIndex >= slides.length) {
          index = 0;
        } else {
          index = newIndex;
        }

        track.style.transform = 'translateX(-' + index * 100 + '%)';

        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === index);
        });

        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          goToSlide(index - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goToSlide(index + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var dotIndex = parseInt(dot.getAttribute('data-an-dot'), 10);
          goToSlide(dotIndex);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
